<div class="cx-section">

  <div class="row header-container">
    <div class="col-12">
      <h1 class="page-title">{{pageTitle}}</h1>
      @if (!showEditAddressForm) {
        <p class="description">{{pageDescription}}</p>
      }
    </div>
  </div>

  @if (!(addressesStateLoading$ | async)) {
    @if (!(addresses$ | async)?.length && !showAddAddressForm) {
      <div class="row">
        <div class="col-md-12 col-lg-5">
          <button class="btn btn-black btn-block btn-lg" (click)="addAddressButtonHandle()">
            {{ 'addressBook.addNewAddress' | cxTranslate }}
          </button>
        </div>
      </div>
    }
    @if ((addresses$ | async)?.length && !(showAddAddressForm || showEditAddressForm)) {
      <div class="mb-4 card-list address-book">
        <div class="row">
          @if ((addresses$ | async); as addresses) {
            @for (address of addresses; track address) {
              <div class="col-lg-6">
                <cx-card [border]="true" [fitToContainer]="true" [content]="getCardContent(address) | async"
                  (editCard)="editAddressButtonHandle(address)"
                  (setDefaultCard)="customSetAddressAsDefault(address.id, address)" (deleteCard)="setEdit(address.id)"
                  [editMode]="address.id === editCard" (cancelCard)="cancelCard()" [shippingCards]="true"
                  [showDefaultText]="true" [length]="addresses.length > 1" [showAddress]="address.defaultAddress">
                </cx-card>
              </div>
            }
          }
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-md-12 col-lg-5">
          <button class="btn btn-block btn-new-address" (click)="addAddressButtonHandle()">
            <app-custom-icons [type]="iconTypes.PLUS"></app-custom-icons>
            {{ 'addressBook.addNewAddress' | cxTranslate }}
          </button>
        </div>
      </div>
    }
    @if (showAddAddressForm) {
      <section>
        <p class="cx-section-msg">
          {{ 'addressBook.addNewShippingAddress' | cxTranslate }}
        </p>
        <cx-address-form [reset]="true" class="cx-form" [showTitleCode]="false"
          [showCancelBtn]="!((addresses$ | async)?.length === 0)"
          actionBtnLabel="{{ 'addressBook.addAddress' | cxTranslate }}"
          cancelBtnLabel="{{ 'addressBook.backToAddressList' | cxTranslate }}"
          [setAsDefaultField]="!((addresses$ | async)?.length === 0)" (submitAddress)="addAddressSubmit($event)"
        (backToAddress)="addAddressCancel()"></cx-address-form>
      </section>
    }
    @if (showEditAddressForm) {
      <section class="mt-4">
        <!--        <p class="cx-section-msg">-->
        <!--          {{ 'addressBook.editShippingAddress' | cxTranslate }}-->
      <!--        </p>-->
      <cx-address-form showTitleCode="true" actionBtnLabel="{{ 'addressBook.updateAddress' | cxTranslate }}"
        cancelBtnLabel="{{ 'addressBook.backToAddressList' | cxTranslate }}" [addressData]="currentAddress"
      (submitAddress)="editAddressSubmit($event)" (backToAddress)="editAddressCancel()"></cx-address-form>
    </section>
  }
} @else {
  <div class="col-md-12 cx-address-spinner">
    <cx-spinner></cx-spinner>
  </div>
}
</div>

